export enum RoleType{
  Regular = 1,
  DeliveryManager = 2,
  ProjectManager = 3,
  Hr = 4,
  Admin = 5,
}
